<template>
  <div>
    <!-- 七天无理由退换列表 -->
    <div class="footer-page mini-width">
      <div class="w-1400 footer-box">
        <div class="footer-item-box" v-for="(item, index) in footerList" :key="index">
          <div class="footer-item">
            <img :src="require(`@/static/index/line/icon-${index}.png`)" :alt="item.title"/>
            <div class="footer-inner">
              <div class="word-title">{{ item.title }}</div>
              <div class="word-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部详细信息展示 -->
    <div class="footer-detail mini-width">
      <div class="w-1400 deteil-inner">

        <el-divider class="line">本网站销售的所有产品用于工业、科研用途，不可用于人体使用</el-divider>
        <!-- 头部信息 -->
        <div class="button-top">
          <!-- 百度智能云 -->
          <div class="baidu-box">
            <div class="baidu-image">
              <img src="../../static/index/logo.png" alt="logo"/>
              <span>化联网</span>
            </div>
            <div class="baidu-phone">
              <div class="phone">{{ configInfo.site_mible }}</div>
              <div class="desc">联系电话</div>
            </div>
            <div class="baidu-phone">
              <div class="phone">{{ configInfo.site_mail }}</div>
              <div class="desc">联系邮箱</div>
            </div>
          </div>
          <!-- 新手入门 -->
          <div class="new-box">
            <div class="new-list" v-for="(num, index) in newList" :key="index">
              <div class="new-title">{{ num.title }}</div>
              <div class="new-item hit-cursor" v-for="(item, ind) in num.children" :key="ind" @click="goPage(item)">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
        <!-- 友情链接列表 -->
        <div class="button-bottom">
          <span class="blod">友情链接：</span>
          <a :href="item.url" target="_blank" v-for="(item, index) in friendLinksList" :key="index">
            {{ item.name }}</a>
        </div>
        <div class="all-desc">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=13010802002566" rel="noreferrer" target="_blank">
            <img class="icon-polic" src="../../static/vip/polic.png" alt="警徽">
            {{ configInfo.gongan_beian }}</a> 版权所有. <a href="https://beian.miit.gov.cn/" target="_blank"
                                                           class="hit-cursor font-wight">
          {{ configInfo.site_icp }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HomeFooter",

  data() {
    return {
      footerList: [
        {
          img: "icon-2.png",
          title: "服务商认证",
          desc: "保证服务品质",
        },
        {
          img: "icon-1.png",
          title: "交易期担保",
          desc: "交易金额投保平台",
        },
        {
          img: "icon-0.png",
          title: "服务过程监管",
          desc: "全周期保障商品服务质量",
        },
      ],
      newList: [
        {
          title: "新手上路",
          children: [
            {
              title: "用户注册",
              url: "/register",
              isLogin: false,
            },
            {
              title: "密码找回",
              url: "/agreement/findPassword",
              isLogin: false,
            },
            {
              title: "退换货管理",
              url: "/agreement/agreement?id=4",
              isLogin: false,
            },
          ],
        },
        {
          title: "用户中心",
          children: [
            {
              title: "快速发布产品",
              url: "/user/supplier/my-project",
              isLogin: true,
            },
            {
              title: "快速发布需求",
              url: "/user/purchase/release",
              isLogin: true,
            },
            {
              title: "成为VIP",
              isLogin: true,
              url: "/vip",
            },
            {
              title: "投诉举报制度",
              isLogin: false,
              url: "/agreement/agreement?id=5",
            },
          ],
        },
        {
          title: "关于平台",
          children: [
            {
              isLogin: false,
              title: "平台介绍",
              url: "/agreement/agreement?id=6",
            },
            {
              isLogin: false,
              title: "商务合作",
              url: "/agreement/agreement?id=7",
            },
            {
              isLogin: false,
              title: "营业执照",
              url: "/agreement/agreement?id=14",
            },
            {
              isLogin: false,
              title: "联系我们",
              url: "/about-us",
            },
          ],
        },
        {
          title: "平台服务",
          children: [
            {
              isLogin: false,
              title: "项目合伙人",
              url: "/agreement/agreement?id=8",
            },
            {
              isLogin: false,
              title: "技术项目交易",
              url: "/technology",
            },
            {
              isLogin: false,
              title: "禁毒知识",
              url: "/agreement/agreement?id=9",
            },
            {
              // todo
              isLogin: false,
              title: "平台法律声明",
              url: "/agreement/agreement?id=13",
            },
          ],
        },
        {
          title: "使用条款",
          children: [
            {
              isLogin: false,
              title: "服务条款",
              url: "/agreement/agreement?id=11",
            },
            {
              isLogin: false,
              title: "法律声明",
              url: "/agreement/agreement?id=10",
            },
            {
              isLogin: false,
              title: "隐私协议",
              url: "/agreement/agreement?id=2",
            },
            {
              isLogin: false,
              title: "免责声明",
              url: "/agreement/agreement?id=12",
            },
          ],
        },
      ],
    };
  },
  computed: {
    configInfo() {
      return this.$store.state.config.config;
    },
    friendLinksList() {
      return this.$store.state.config.friendLinksList;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  mounted() {
    this.$store.dispatch("getFriendLinks");
  },
  methods: {
    async goPage(item) {
      if (item.isLogin) {
        if (this.mixCheckLogin() && this.mixCheckUserAudit()) {
            this.$router.push({path: item.url});
        }
      } else {
        this.$router.push({path: item.url});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.font-wight {
  color: #fff;
  text-decoration: none;
}

.footer-page {
  background: url("../../static/index/line.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 140px;

  .footer-box {
    color: #ffffff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
    padding: 0 100px;
    //background: #034ae5;
    box-sizing: border-box;

    .footer-item-box {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .footer-item {
      display: flex;
      align-items: center;
    }

    img {
      width: 50px;
      height: 50px;
    }

    .footer-inner {
      color: #ffffff;
      margin-left: 20px;

      .word-title {
        font-size: var(--font-size-default-20);
        font-weight: bold;
        margin-bottom: 10px;
      }

      .word-desc {
        font-size: var(--font-size-default-14);
      }
    }
  }
}

.footer-detail {
  background: #373f5d;
  padding: 30px 0 50px;
  color: #ffffff;

  .deteil-inner {
    box-sizing: border-box;

    .line {
      margin: 40px 0 60px;

      .el-divider__text {
        background-color: #373F5D;
        color: #ffffff;
      }
    }

    .button-top {
      display: flex;
      justify-content: space-between;

      .baidu-box {
        .baidu-image {
          display: flex;
          align-items: center;
          font-size: var(--font-size-default-18);
          font-weight: bold;
          margin-bottom: 10px;

          img {
            width: 30px;
            height: 30px;
            margin-right: 4px;
          }
        }
      }

      .baidu-phone {
        margin-bottom: 20px;

        .phone {
          font-size: var(--font-size-default-18);
          font-weight: bold;
          margin-bottom: 5px;
        }

        .desc {
          font-size: 14px;
        }
      }

      .baidu-img {
        display: flex;
        gap: 18px;

        .icon-hover-box {
          position: relative;
          display: inline-block;

          .icon {
            width: 50px;
            height: 50px;
            cursor: pointer;
          }

          .hover-pop {
            display: none;
            position: absolute;
            // left: 25%;
            top: 110%;
            // transform: translateX(-50%);
            background: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
            padding: 10px 16px;
            z-index: 10;
            white-space: nowrap;
            font-size: 15px;
            color: #222;
            min-width: 120px;
            text-align: center;
          }

          .wechat-pop img {
            width: 100px;
            height: 100px;
          }

          &:hover .hover-pop {
            display: block;
            animation: fadeIn 0.2s;
          }
        }
      }
    }

    .new-box {
      flex: 1;
      display: flex;
      margin-left: 150px;
      justify-content: space-between;

      .new-list {
        .new-title {
          font-size: var(--font-size-default-20);
          font-weight: bold;
          margin-bottom: 30px;
        }

        .new-item {
          font-size: var(--font-size-default-14);
          margin-bottom: 10px;
        }
      }
    }
  }

  .button-bottom {
    margin: 0px 0 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-around;
    border-top: 1px solid #f1f1f140;
    border-bottom: 1px solid #f1f1f140;
    gap: 24px;
    font-size: var(--font-size-default-14);

    .blod {
      font-weight: bold;
    }

    a {
      color: #ffffff;
      text-decoration: none;
    }
  }

  .all-desc {
    font-size: var(--font-size-default-14);
    text-align: center;

    a {
      color: #fff1f0;
      text-decoration: none;
    }

    .icon-polic {
      width: 20px;
      height: 20px;
      vertical-align: middle;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
